import { Alert, Box, Icon, Text } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { IoPaperPlaneOutline } from 'react-icons/io5';
import { BsArrowRight } from 'react-icons/bs';
import { ROUTERS } from '../../../data';
import { CustomNavLink } from '../../Links/CustomNavLink';
import { ReactNode } from 'react';

const SendToInvitationLink = ({
  children,
  memberId,
  userName,
  ...restProps
}: {
  children: ReactNode;
  memberId: string;
  userName: string;
  [key: string]: any;
}) => (
  <CustomNavLink to={ROUTERS.USER.MEMBER_TO_USER} state={{ memberId, userName }} {...restProps}>
    {children}
  </CustomNavLink>
);

export const InvitationBlock = ({ memberId, userName }: { memberId: string; userName: string }) => {
  const { t } = useTranslation();

  return (
    <Alert status='info' maxW='2xl' flexDir={{ base: 'column', lg: 'row' }} textAlign={{ base: 'center', lg: 'left' }}>
      <Icon as={IoPaperPlaneOutline} mr={4} mt={{ base: 2, lg: 0 }} fontSize='xl' />
      <Box flexGrow={1} my={{ base: 3, lg: 0 }}>
        <Text>{t('member.edit.invitation.text.1')}</Text>
        <Text>
          <SendToInvitationLink variant='underlinePrimary' fontWeight='bold' memberId={memberId} userName={userName}>
            {t('member.edit.invitation.text.2')}
          </SendToInvitationLink>
        </Text>
      </Box>
      <SendToInvitationLink memberId={memberId} userName={userName}>
        <Icon as={BsArrowRight} fontSize='xl' color='brand.cyan' />
      </SendToInvitationLink>
    </Alert>
  );
};
